export const SET_APPOINTMENT_FORMS_DATA = 'SET_APPOINTMENT_FORMS_DATA';